import { render, staticRenderFns } from "./performanceData.vue?vue&type=template&id=8c59acda&scoped=true"
import script from "./performanceData.vue?vue&type=script&lang=js"
export * from "./performanceData.vue?vue&type=script&lang=js"
import style0 from "./performanceData.vue?vue&type=style&index=0&id=8c59acda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c59acda",
  null
  
)

export default component.exports